export default function convertASCII(str: string) {
  return [...str].map(
    (char) => `0x${char.charCodeAt(0).toString(16).padStart(2, '0')}`
  );
}
